import cloneDeep from 'lodash/cloneDeep';

import {
    EXPENSE_REIMBURSE_CONST
} from "../actionConstants";
import { EXPENSE_CONSTANTS } from '../../AppConstants'

import {
    filterConfig
} from '../../expense/pages/ExpenseReimburse/config';
import { presetFilters, formatData, handleSelected, formatFilterCounts } from "../../expense/pages/ExpenseReimburse/utils";

const filtersObject = presetFilters(filterConfig, []);

const INITIAL_STATE = {
    filters: filtersObject.filters,
    list: false,
    appliedFilters: filtersObject.appliedFilters,
    selectedList: {},
    listApiCalled: false,
    pageDataApi: false,
    isListError: false,
    listCalling: true,
    uploadState: 'form',
    modal: false,
    reimbursedCount: '',
    isAllSelected: false,
    feature: 0,
    searching: false,
    searchError: false,
    searchListLeft: false,
    searchList: false,
    sendSearchData:false,
    query:{
        [filterConfig.expenseStatus.key]: EXPENSE_CONSTANTS[EXPENSE_CONSTANTS.DEF_TAB],
        pageNo: 0,
        limit: EXPENSE_CONSTANTS.PAGE_LIMIT * 2,
        sort: {
            key: EXPENSE_CONSTANTS.DEF_SORT_KEY,
            value: EXPENSE_CONSTANTS.DESCENDING
        },
        ...filtersObject.query
    },
    tneDownload: {}
};

export default (state = INITIAL_STATE, action) => {
    if (!action) {
        return state;
    }
    const { type, payload } = action;
    switch (type) {
        case EXPENSE_REIMBURSE_CONST.GET_LIST: {
            const { data={}, isScroll=false } = payload
            const listData = formatData(data.expenses, state.isAllSelected);
            let updatedList = listData.list;
            if(isScroll) {
                updatedList = [...state.list, ...listData.list];
            }
            return {
                ...state,
                list: updatedList,
                listApiCalled: true,
                listCalling: false,
                lastPageIndex: listData.lastIndex,
                selectedList: {...state.selectedList, ...listData.selectedList},
                pageDataApi: listData.list.length < EXPENSE_CONSTANTS.PAGE_LIMIT,
                isListError: false,
                reimbursedCount: state.modal === EXPENSE_CONSTANTS.REIMB_POPUP,
            }
        }

        case EXPENSE_REIMBURSE_CONST.GET_LIST_CALLING: {
            const { isScroll=false } = payload;
            return {
                ...state,
                list: isScroll ? state.list : false,
                listCalling: true,
                listApiCalled: false,
                isListError: false
            }
        }

        case EXPENSE_REIMBURSE_CONST.GET_LIST_FAILED: {
            return {
                ...state,
                listApiCalled: true,
                isListError: !state.list,
                listCalling: false
            }
        }

        case EXPENSE_REIMBURSE_CONST.UPDATE_SELECTED: {
            const selectedList = handleSelected(state.selectedList, payload);
            const { selectAll } = payload;
            let updateList = state.list
            if(typeof selectAll !== "undefined") {
                updateList = [...selectedList.itemList]
            }
            return {
                ...state,
                selectedList: selectedList.selectedList,
                reimbursedCount: false,
                isAllSelected: selectAll,
                list: updateList
            }
        }

        case EXPENSE_REIMBURSE_CONST.UPDATE_FILTER_QUERY: {
            return {
                ...state,
                query: cloneDeep(payload),
            }
        }

        case EXPENSE_REIMBURSE_CONST.UPDATE_FILTER_DATA: {
            const { filters=state.filters, appliedFilters=state.appliedFilters} = payload;
            return {
                ...state,
                filters: cloneDeep(filters),
                listApiCalled: false,
                appliedFilters: cloneDeep(appliedFilters)
            }
        }

        case EXPENSE_REIMBURSE_CONST.GET_FILTER_COUNTS: {
            const filters = formatFilterCounts(payload.data.count, state.filters)
            return {
                ...state,
                filters: filters
            }
        }

        case EXPENSE_REIMBURSE_CONST.DOWNLOAD_START: {
            const filters = formatFilterCounts(payload.data.count, state.filters)
            return {
                ...state,
                downloading: filters
            }
        }

        case EXPENSE_REIMBURSE_CONST.SET_MODAL: {
            return {
                ...state,
                modal: payload
            }
        }

        case EXPENSE_REIMBURSE_CONST.UPLOAD_FAILED: {
            return {
                ...state,
                uploadError: true
            }
        }
        case EXPENSE_REIMBURSE_CONST.UPLOAD_SUCCESS: {
            return {
                ...state,
                reimbursedCount: payload || true,
                selectedList: {},
            }
        }

        case EXPENSE_REIMBURSE_CONST.CANCEL_UPLOAD: {
            return {
                ...state,
                uploadState: 'form'
            }
        }

        case EXPENSE_REIMBURSE_CONST.SEARCH_LIST_CALLING: {
            return {
                ...state,
                searching: !payload.isScroll,
                searchError: false,
                sendSearchData: payload.sendSearchData
            }
        }

        case EXPENSE_REIMBURSE_CONST.SEARCH_LIST_SUCCESS: {
            const { data={}, isScroll=false } = payload;
            const listData = formatData(data.expenses, state.isAllSelected);
            let updatedList = listData.list;
            if(isScroll) {
                updatedList = [...state.searchList, ...listData.list];
            }
            return {
                ...state,
                searching: false,
                searchError: false,
                searchListLeft: listData.list.length < EXPENSE_CONSTANTS.PAGE_LIMIT,
                searchList: updatedList
            }
        }

        case EXPENSE_REIMBURSE_CONST.SEARCH_LIST_FAILED: {
            return {
                ...state,
                searching: false,
                searchError: true,
            }
        }

        case EXPENSE_REIMBURSE_CONST.SEARCH_LIST_RESET: {
            return {
                ...state,
                searching: false,
                searchError: false,
            }
        }

        case EXPENSE_REIMBURSE_CONST.DOWNLOAD_TnE: {
            const {sendEmail, actualCount, maxCount} = payload;
            return {
                ...state,
                tneDownload: {
                    ...state.tneDownload,
                    sendEmail,
                    actualCount,
                    maxCount,
                }
            }
        }

        default: 
            return state
    }
}
